import { render, staticRenderFns } from "./opportunity_with_us.vue?vue&type=template&id=6bd9ef91&scoped=true&"
import script from "./opportunity_with_us.vue?vue&type=script&lang=js&"
export * from "./opportunity_with_us.vue?vue&type=script&lang=js&"
import style0 from "./opportunity_with_us.vue?vue&type=style&index=0&id=6bd9ef91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9ef91",
  null
  
)

export default component.exports